import React, { useEffect, useState } from "react";
import { Paper, withStyles } from '@material-ui/core';
import MUIDataTable from "mui-datatables";
import { connect } from "react-redux";
import * as actions from "../../../actions/review";
import FormDialogAddReview from "../formDialog/FormDialogAddReview";
import FormDialogEditReview from "../formDialog/FormDialogEditReview";
import FormDialogDeleteReview from "../formDialog/FormDialogDeleteReview";

const styles = theme => ({
    paperTable: {
        padding: theme.spacing(0),
    }
})

const ReviewTable = ({ classes, ...props }) => {
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(15)

    useEffect(() => {
        props.fetchPagination(1, rowsPerPage)
    }, [])

    const handleChangePage = async (newPage) => {
        await setPage(newPage);
        props.fetchPagination(newPage + 1, rowsPerPage)
    };

    const handleChangeRowsPerPage = async (rowsPerPage) => {
        await setRowsPerPage(rowsPerPage);
        await setPage(0);
        props.fetchPagination(1, rowsPerPage)
    };

    const handleSearch = async (searchText) => {
        await setPage(0);
        props.fetchPagination(1, rowsPerPage, searchText, searchText)
    };

    const handleFilterChange = async (title,description) => {
        await setPage(0);
        props.fetchPagination(1, rowsPerPage, title, description)
    };

    const refresh = async () => {
        await setPage(0);
        props.fetchPagination(1, rowsPerPage)
    }
    
    const columns = [
        {
            name: "id",
            label: "ID",
            options: {
                display: false,
                filter: false,
                sort: false,
            }
        },
        {
            name: "customerName",
            label: "Customer Name",
            options: {
                filter: true,
                sort: false,
            }
        },
        {
            // left side of first column is too close with the container, give more space on it
            name: "rating",
            label: "Rating",
            options: {
                filter: true,
                sort: false,
                customHeadRender: (columnMeta, handleToggleColumn) => {
                    return (
                        <th key={columnMeta.index} 
                            style={{
                                paddingLeft: "31px", 
                                fontWeight:500, 
                                borderBottom: "1px solid rgba(224, 224, 224, .5)" 
                                }}
                        >
                            <div style={{display:"flex", flexDirection:"row", justifyContent:"flex-start"}}>
                                {columnMeta.label}
                            </div>
                        </th>
                    );
                },
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <span style={{marginLeft:15}}>
                            {value}
                        </span>
                    );
                }
            },
            
        },
      
        {
            name: "description",
            label: "Description",
            options: {
                filter: true,
                sort: false,
            }
        },
        
       
        // {
        //     name: "createdDate",
        //     label: "Registration Date",
        //     options: {
        //         filter: false,
        //         sort: false,
        //     }
        // },
        {
            name: "",
            options: {
                filter: false,
                sort: false,
                empty: true,
                // customHeadRender: (columnMeta, handleToggleColumn) => {
                //     return (
                //         <th key={columnMeta.index} style={{paddingRight: "16px"}}>
                //             <div style={{display:"flex", flexDirection:"row", justifyContent:"flex-end"}}>
                //                 {/* <FormDialogAddReview component={Paper}  
                //                     create={props.create}
                //                     refresh={refresh}
                //                 /> */}
                                
                //             </div>
                //         </th>
                //     );
                // },
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <div style={{display:"flex", flexDirection:"row", justifyContent:"flex-end"}}>
                            {/* <FormDialogEditReview
                                dataReview={tableMeta.rowData}
                                update={props.update}
                            /> */}
                            <FormDialogDeleteReview 
                                dataReview={tableMeta.rowData}
                                delete={props.delete}
                                refresh={refresh}
                            />
                        </div>
                    );
                }
            }
        }
    ];

    const options = {
        filter: false,
        filterType: 'textField',
        responsive: 'stacked',
        selectableRows: false,
        rowsPerPageOptions: [5, 10, 25],
        serverSide: true,
        viewColumns: false,
        print: false,
        download: false,

        rowsPerPage: rowsPerPage,
        count: props?.meta?.totalDocs || 0,
        page: page,

        onTableChange: (action, tableState) => {
            switch (action) {
              case 'changePage':
                handleChangePage(tableState.page)
                break;

            case 'changeRowsPerPage':
                handleChangeRowsPerPage(tableState.rowsPerPage)
                break;

            case 'search':
                handleSearch(tableState.searchText)
                break;

            case 'filterChange':
                handleFilterChange(tableState.filterList[1], tableState.filterList[2])
                break;
            
            case 'resetFilters':
                handleSearch("")
                break;
                 
              default:
                break;
            }
        },
    };
    
    return (
        <MUIDataTable className={classes.paperTable}
            data={props.reviews}
            columns={columns}
            options={options}
        />
    );
}

const mapStateToProps = state => ({
    reviews: state?.review?.reviews,
    meta: state?.review?.metaReview
})

const mapActionToProps = {
    fetchPagination: actions.Pagination,
    create: actions.create,
    update: actions.update,
    delete: actions.Delete
}

export default connect(mapStateToProps, mapActionToProps)(withStyles(styles)(ReviewTable));